import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import GridViewIcon from "@mui/icons-material/GridView";

export type ViewMode = "list" | "tile";

export type ViewModeToggleProps = {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
  ariaLabel?: string;
};

export const ViewModeToggle = ({
  value,
  onChange,
  ariaLabel = "view mode",
}: ViewModeToggleProps) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    size="small"
    onChange={(_, next: ViewMode | null) => {
      if (next !== null) onChange(next);
    }}
    aria-label={ariaLabel}
  >
    <ToggleButton value="list" aria-label="list view">
      <ViewListIcon fontSize="small" />
    </ToggleButton>
    <ToggleButton value="tile" aria-label="tile view">
      <GridViewIcon fontSize="small" />
    </ToggleButton>
  </ToggleButtonGroup>
);
